import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Stack, CircularProgress
} from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import Config from '../../ckcore/core/Config';

export default function AddPartnerDialog({ open, onClose, onCreated }) {
  const { keycloak } = useKeycloak();
  const [form, setForm] = useState({ name: '', website: '', logo: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleCreate = async () => {
    setLoading(true);
    setMessage('');
    try {
      const resp = await fetch(
        `${Config.getServerURL()}/api/v2/partners/create`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          body: JSON.stringify(form),
        }
      );
      const data = await resp.json();
      if (resp.ok && data.statusId === 1 /* SUCCESS */) {
        setMessage('Tạo tổ chức thành công!');
        onCreated(data.partner.partnerId); // partnerId trả về từ backend
      } else {
        setMessage(data.message || 'Không thể tạo tổ chức');
      }
    } catch (err) {
      setMessage('Lỗi mạng, vui lòng thử lại');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Tạo tổ chức mới</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            required
            label="Tên tổ chức"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Website"
            name="website"
            value={form.website}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Logo URL"
            name="logo"
            value={form.logo}
            onChange={handleChange}
            fullWidth
          />
          {message && <span style={{ color: 'red' }}>{message}</span>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Huỷ</Button>
        <Button
          variant="contained"
          onClick={handleCreate}
          disabled={loading || !form.name.trim()}
          startIcon={loading && <CircularProgress size={16} color="inherit" />}
        >
          Tạo
        </Button>
      </DialogActions>
    </Dialog>
  );
}
